import React from 'react';
import { MenuItem } from '@mui/material';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import {MIN_MAX_READER, PROTOCOL_DATA, READER_MODE_DATA, READER_NUMBER_DATA, YES_NO_DATA} from '../Model/Models';
import CreateReaderApp from '../Functionality/CreateReaderApp';

const CreateReaderModal = (props) => {
    const { onHide, controllerId = null, setModified } = props;

    const { t, emptyFields, isValid, controller, sioIds, reader, handleChange, handleChangeReaderNumber, handleSubmit, resetValues } =
        CreateReaderApp({ onHide: onHide, controllerId: controllerId, setModified });

    return (
        <>
            <CustomModal
                title={"create_reader"}
                size='lg'
                buttonConfirm='confirm'
                {...props}
                onHide={() => {
                    onHide();
                    resetValues();
                }}
                onConfirm={() => {
                    handleSubmit();
                }}
                classNameBody="pt-2"
            >
                <div className='row'>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField id={"txt_crm_name"}
                            trans={"name"}
                            name={"name"}
                            type={"text"}
                            value={reader.name}
                            onChange={handleChange}
                            required={true}
                            emptyFields={emptyFields}
                            length={128}
                        />
                    </div>
                    {controllerId == null &&
                        <div className='col-sm-12 col-xxl-6 col-lg-6'>
                            <CustomSelectAndChildren
                                id={"slt_crm_controller"}
                                name={"controllerId"}
                                trans={"controller"}
                                value={reader.controllerId}
                                onChange={handleChange}
                                required={true}
                                emptyFields={emptyFields}
                                showNoSelectionOption={false}
                            >
                                {Array.isArray(controller) &&
                                controller.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </CustomSelectAndChildren>
                        </div>
                    }

                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelectAndChildren
                            id={"slt_crm_sio"}
                            name={"hidSioId"}
                            trans={"SIO"}
                            value={reader.hidSioId}
                            onChange={handleChange}
                            required={true}
                            emptyFields={emptyFields}
                            showNoSelectionOption={false}
                            disabled={!reader.controllerId}
                        >
                            {Array.isArray(sioIds) &&
                                sioIds.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name.toUpperCase()}
                                    </MenuItem>
                                ))}
                        </CustomSelectAndChildren>
                    </div>

                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelectAndChildren
                            id={"slt_crm_reader"}
                            name={"readerNo"}
                            trans={"reader_number"}
                            value={reader.readerNo}
                            onChange={handleChangeReaderNumber}
                            required={true}
                            emptyFields={emptyFields}
                            showNoSelectionOption={false}
                        >
                            {Object.values(READER_NUMBER_DATA).map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {t(item.name)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>

                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelectAndChildren id={"slt_crm_key_pad"}
                            name={"hasKeyPad"}
                            trans={"key_pad"}
                            value={reader.hasKeyPad}
                            onChange={handleChange}
                            required={true}
                            emptyFields={emptyFields}
                            showNoSelectionOption={false}
                        >
                            {Object.values(YES_NO_DATA).map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {t(item.name)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>

                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelectAndChildren
                            id={"slt_crm_protocol"}
                            name={"communicationProtocol"}
                            trans={"communication_protocol"}
                            value={reader.communicationProtocol}
                            onChange={handleChange}
                            required={true}
                            emptyFields={emptyFields}
                            showNoSelectionOption={false}
                        >
                            {Object.values(PROTOCOL_DATA).map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {t(item.name)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>

                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelectAndChildren
                            id={"slt_crm_reader_mode"}
                            name={"readerMode"}
                            trans={"reader_mode"}
                            value={reader.readerMode}
                            onChange={handleChange}
                            required={true}
                            emptyFields={emptyFields}
                            showNoSelectionOption={false}
                        >
                            {Object.values(READER_MODE_DATA).map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {t(item.name)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>

                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField id={"txt_crm_keep_open"}
                            name={"keepOpen"}
                            trans={"keep_open"}
                            type={"number"}
                            value={reader.keepOpen}
                            onChange={handleChange}
                            required={true}
                            emptyFields={emptyFields}
                            length={1}
                            isValid={isValid}
                            isValidText={t('it_must_be_greater_than_or_equal_to', {min:MIN_MAX_READER.KEEP_OPEN.start})}
                            helperText={t('it_must_be_greater_than_or_equal_to', {min:MIN_MAX_READER.KEEP_OPEN.start})}
                        />
                    </div>

                </div>
            </CustomModal>
        </>
    );
};

export default CreateReaderModal;
